import React, { useState, useEffect, useRef } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import axios from "axios";
import PageNotFound from "../PageNotFound/PageNotFound";
import Navbar from "../MainWebsite/Shared/NavBar/Navbar";
import Index from "../MainWebsite/pages/index/Index";
import Contact from "../MainWebsite/pages/contact/contact";
import FAQ from "../MainWebsite/pages/FAQ/FAQ";
import ProductsByBrand from "../MainWebsite/pages/ProductsByBrand/ProductsByBrand";
import ProductsByCategory from "../MainWebsite/pages/ProductsByCategory/ProductsByCategory";
import ProductDetails from "../MainWebsite/pages/ProductDetails/ProductDetails";
import Loading from "../MainWebsite/Components/Loading/Loading";
import { createSlug } from "../utils/createSlug";

function MainRoutes() {
  const location = useLocation();
  const [Products, setProducts] = useState([]);
  const [sortedBrands, setSortedBrands] = useState([]);
  const [sortedCategories, setSortedCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL +
          "api/Products/ProductRoutesAndFilter"
      );

      if (response.data) {
        setProducts(response.data);
        const { sortedBrands, sortedCategories } = transformData(response.data);
        setSortedBrands(sortedBrands);
        setSortedCategories(sortedCategories);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  const isFetched = useRef(false);
  useEffect(() => {
    if (!isFetched.current) {
      getProducts();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);

  const transformData = (products) => {
    const brandMap = {};
    const categoryMap = {};

    products.forEach((product) => {
      const { brand, category } = product;

      // --- Handle Brands ---
      if (brand) {
        if (!brandMap[brand.name]) {
          brandMap[brand.name] = { ...brand, products: [] };
        }
        brandMap[brand.name].products.push(product);
      }

      // --- Handle Categories ---
      if (category) {
        if (!categoryMap[category.name]) {
          categoryMap[category.name] = { ...category, products: [] };
        }
        categoryMap[category.name].products.push(product);
      }
    });

    // Sort brands/categories by sortOrder, and products by name
    const sortedBrands = Object.values(brandMap).sort(
      (a, b) => a.sortOrder - b.sortOrder
    );

    const sortedCategories = Object.values(categoryMap).sort(
      (a, b) => a.sortOrder - b.sortOrder
    );
    // Sort products inside each brand
    sortedBrands.forEach((brand) => {
      brand.products.sort((a, b) => a.sortOrder - b.sortOrder);
    });

    // Sort products inside each category
    sortedCategories.forEach((category) => {
      category.products.sort((a, b) => a.sortOrder - b.sortOrder);
    });
    return { sortedBrands, sortedCategories };
  };

  useEffect(() => {
    const isFAQ = location.pathname === "/faq";
    const isProductPage =
      location.pathname.includes("productsByCategory") ||
      location.pathname.includes("productsByBrand");

    if (isFAQ) {
      document.body.style.backgroundColor = "#010203";
    } else if (isProductPage) {
      document.body.style.backgroundColor = "#CBD6E4"; // Example background color
    } else {
      document.body.style.backgroundColor = "";
    }

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, [location.pathname]);

  if (loading) return <Loading />;
  return (
    <>
      <Navbar />
      <Routes>
        <Route index element={<Index />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        {sortedBrands.length > 0 && (
          <Route
            path="/productsByBrand"
            element={<ProductsByBrand brands={sortedBrands} />}
          />
        )}
        {sortedCategories.length > 0 && (
          <Route
            path="/productsByCategory"
            element={<ProductsByCategory categories={sortedCategories} />}
          />
        )}

        {Products.length > 0 &&
          Products.map((product, index) => {
            const productCount = Products.length;
            const prevIndex = (index - 1 + productCount) % productCount;
            const nextIndex = (index + 1) % productCount;

            const prevProductSlug = createSlug(Products[prevIndex].name);
            const nextProductSlug = createSlug(Products[nextIndex].name);
            const productSlug = createSlug(product.name);

            return (
              <Route
                key={product.id || productSlug}
                path={`/product/${productSlug}`}
                element={
                  <ProductDetails
                    productName={product.name}
                    prevProduct={`/product/${prevProductSlug}`}
                    nextProduct={`/product/${nextProductSlug}`}
                  />
                }
              />
            );
          })}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default MainRoutes;
